
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"flexibleProjectsOrPortfolios"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"flexibleSection_projectsOrPortfolios_BlockType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"flexibleSection_projectsOrPortfolios_BlockType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"header"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkBlock"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"linkBlock"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"projectsOrPortfolios"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"projectMinimal"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"portfolioMinimal"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"projectMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_projects_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultImageAsset"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"cardImage"},"name":{"kind":"Name","value":"projectCardImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultImageAsset"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"portfolioMinimal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portfolio_portfolio_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultImageAsset"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"cardImage"},"name":{"kind":"Name","value":"projectCardImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultImageAsset"},"directives":[]}]}}]}}],"loc":{"start":0,"end":916}};
    doc.loc.source = {"body":"#import \"~/graphql/fragments/linkBlock.graphql\"\n#import \"~/graphql/fragments/defaultImageAsset.graphql\"\n\nfragment flexibleProjectsOrPortfolios on flexibleSection_projectsOrPortfolios_BlockType {\n    __typename\n    ... on flexibleSection_projectsOrPortfolios_BlockType {\n        background\n        header\n        linkBlock {\n            ... linkBlock\n        }\n        projectsOrPortfolios {\n            __typename\n            id\n            slug\n            title\n            ... projectMinimal\n            ... portfolioMinimal\n        }\n    }\n}\n\nfragment projectMinimal on projects_projects_Entry {\n    featuredImage {\n        ... DefaultImageAsset\n    }\n    cardImage: projectCardImage {\n        ... DefaultImageAsset\n    }\n}\n\nfragment portfolioMinimal on portfolio_portfolio_Entry {\n    featuredImage {\n        ... DefaultImageAsset\n    }\n    cardImage: projectCardImage {\n        ... DefaultImageAsset\n    }\n}\n\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/linkBlock.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/defaultImageAsset.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["flexibleProjectsOrPortfolios"] = oneQuery(doc, "flexibleProjectsOrPortfolios");
        
        module.exports["projectMinimal"] = oneQuery(doc, "projectMinimal");
        
        module.exports["portfolioMinimal"] = oneQuery(doc, "portfolioMinimal");
        
